// import { fromJS, Map } from 'immutable';

export const initialState = {
  list: {
    data: [],
    loading: true,
  },
  info: {
    data: [],
    loading: true,
  },
  listGroup: {
    data: {},
    loading: true,
  },
  isUpdatePermission: {
    data: {},
    loading: true,
  },
  isUpdateName: {
    data: {},
    loading: true,
  },
  listTemplate: {
    data: [],
    loading: true,
  },
  isCreatedGroup: {
    data: {},
    loading: true,
  },
  listGroupScheduleProject: {
    data: {},
    loading: false,
  },
  createGroupScheduleProject: {
    data: {},
    loading: false,
  },
  updateGroupScheduleProject: {
    data: {},
    loading: false
  },
  deleteGroupScheduleProject: {
    data: {},
    loading: false
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "GET_LIST_GROUP_ASSIGNMENT_REQUEST":
      return {
        ...state,
        list: { ...initialState.list },
      };
    case "GET_LIST_GROUP_ASSIGNMENT_SUCCESS": {
      if (action.payload.data) {
        return {
          ...state,
          list: { ...action.payload },
        };
      }
      return { ...state };
    }
    case "GET_INFO_GROUP_ASSIGNMENT_REQUEST":
      return {
        ...state,
        info: { ...initialState.info },
      };
    case "GET_INFO_GROUP_ASSIGNMENT_SUCCESS": {
      if (action.payload.data) {
        return {
          ...state,
          info: { ...action.payload },
        };
      }
      return { ...state };
    }
    case "GET_LIST_GROUP_REQUEST":
      return {
        ...state,
        listGroup: { ...initialState.listGroup },
      };
    case "GET_LIST_GROUP_SUCCESS": {
      return { ...state, listGroup: { data: action.payload, loading: false } };
    }
    case "UPDATE_PERMISSION_GROUP_REQUEST":
      return {
        ...state,
        isUpdatePermission: { ...initialState.isUpdatePermission },
      };
    case "UPDATE_PERMISSION_GROUP_SUCCESS": {
      return {
        ...state,
        isUpdatePermission: { data: action.payload, loading: false },
        info: { ...action.payload, loading: false },
      };
    }
    case "UPDATE_NAME_GROUP_REQUEST":
      return {
        ...state,
        isUpdateName: { ...initialState.isUpdateName },
      };
    case "UPDATE_NAME_GROUP_SUCCESS": {
      return {
        ...state,
        isUpdateName: { data: action.payload, loading: false },
      };
    }
    case "GET_TEMPLATE_REQUEST":
      return {
        ...state,
        listTemplate: { ...initialState.listTemplate },
      };
    case "GET_TEMPLATE_SUCCESS": {
      return {
        ...state,
        listTemplate: { data: action.payload.data, loading: false },
      };
    }
    case "CREATE_GROUP_REQUEST":
      return {
        ...state,
        isCreatedGroup: { ...initialState.isCreatedGroup },
      };
    case "CREATE_GROUP_SUCCESS": {
      return {
        ...state,
        isCreatedGroup: { data: action.payload, loading: false },
      };
    }
    case "CREATE_GROUP_SCHEDULE_PROJECT_REQUEST": {
      return {
        ...state,
        createGroupScheduleProject: {
          ...initialState.createGroupScheduleProject,
          loading: true,
        },
      };
    }
    case "CREATE_GROUP_SCHEDULE_PROJECT_SUCCESS": {
      return {
        ...state,
        createGroupScheduleProject: {
          data: action.payload,
          loading: false,
        },
      };
    }
    case "GET_LIST_GROUP_SCHEDULE_PROJECT_REQUEST": {
      return {
        ...state,
        listGroupScheduleProject: {
          data: state.listGroupScheduleProject.data,
          loading: true,
        },
      };
    }
    case "GET_LIST_GROUP_SCHEDULE_PROJECT_SUCCESS": {
      return {
        ...state,
        listGroupScheduleProject: {
          loading: false,
          data: action.payload,
        },
      };
    }
    case "UPDATE_GROUP_SCHEDULE_PROJECT_REQUEST": {
      return {
        ...state,
        updateGroupScheduleProject: {
          ...initialState.updateGroupScheduleProject,
          loading: true
        }
      }
    }
    case "UPDATE_GROUP_SCHEDULE_PROJECT_SUCCESS": {
      return {
        ...state,
        updateGroupScheduleProject: {
          data: action.payload,
          loading: false
        }
      }
    }
    case "DELETE_GROUP_SCHEDULE_PROJECT_REQUEST": {
      return {
        ...state,
        deleteGroupScheduleProject: {
          ...initialState.deleteGroupScheduleProject,
          loading: true
        }
      }
    }
    case "DELETE_GROUP_SCHEDULE_PROJECT_SUCCESS": {
      return {
        ...state,
        deleteGroupScheduleProject: {
          loading: false,
          data: action.payload
        }
      }
    }
    default:
      return state;
  }
};
